import React, { useState } from "react";
import { LeadViewDetailsViewPrimaryInfoProps } from "./lead-view-details-view-primary-info.props";
import AvatarIcon from "../../../../../../assets/icons/avatar.svg";
import "./lead-view-details-view-primary-info.scss";
import ProfileImageUploadComponent from "../../../../../../common/components/edit-upload-image/ProfileImageUploadComponent";
import PhoneIcon from "../../../../../../assets/icons/phone.svg";
import MailIcon from "../../../../../../assets/icons/mail.svg";
import SMSIcon from "../../../../../../assets/icons/sms.svg";
import LeadsStatus from "../../../../leads-status";
import ContactLink from "../../../../../../common/components/contact-link/contact-link";
import { useLogin } from "../../../../../../common/hooks/useUser";
import RenderCellContent from "../../../render-cell-content";
import { leadLinkActivityLog, sendLeadSMSAndActivityLog } from "../../../../../../api/lead";
import SendSmsPopup from "../../../../../send-sms-popup/send-sms-popup";
import { isValidPhoneNumber } from "../../../../../../utils/utils";

const LeadViewDetailsViewPrimaryInfo: React.FC<
  LeadViewDetailsViewPrimaryInfoProps
> = (props: any) => {
  const {
    leadDetails,
    viewPrimaryInfoOpen,
    setViewPrimaryInfoOpen,
    viewFullInfoOpen,
    uploadedImage,
    setUploadedImage,
    setUploadedImageFile,
    setRemoveImage,
    isMobile,
    uploadError,
    setUploadError,
    setAlertMessage,
    setAlertType,
    setAlertOpen,
  } = props;
  const { loginDetails } = useLogin();
  const isTwilioConfigured = loginDetails?.isTwilioConfigured;
  const handleEditOpen = () => setViewPrimaryInfoOpen(!viewPrimaryInfoOpen);
  const [isImageRemoved, setIsImageRemoved] = useState(false);
  const { tenantDetails } = useLogin();
  const [sendSmsPopupOpen, setSendSmsPopupOpen] = useState(false);
  const checkDisableField = () => {
    return tenantDetails?.tenantType === "SuperTenant" &&
      leadDetails?.assigned_to &&
      !(leadDetails?.lead_status === "Closed-Lost")
      ? true
      : false;
  };

  const handleProfileUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const fileSizeInMB = file.size / (1024 * 1024);
      if (fileSizeInMB > 10) {
        setUploadError("File size should not exceed 10MB");
        return;
      }
      setUploadedImageFile(file);
      setIsImageRemoved(false);
      setUploadedImage(URL.createObjectURL(file));
      setUploadError(null);
    }
  };
  const handleRemoveImage = () => {
    setUploadedImage(null);
    setUploadedImageFile(null);
    setIsImageRemoved(true); // triggers fallback to placeholder image
    setRemoveImage(true);
  };
  const sendLeadSMS = async (data: {message: string}) => {
    try {
      const { message } = data;
      const res = await sendLeadSMSAndActivityLog(leadDetails?.id, { message, contactType: "SMS", contactValue: leadDetails?.primary_phone_number });
      if (res.data.success) {
        setAlertMessage("SMS sent successfully");
        setAlertType("success");
        setAlertOpen(true);
      }
    } catch (error: any) {
      console.error(error);
      if (setAlertMessage && setAlertType && setAlertOpen) {
        setAlertMessage(error?.response?.data?.message ??"Failed to send SMS");
        setAlertType("error");
        setAlertOpen(true);
      }
    }
  }
  return (
    <div className="lead-list-view-details-view-box-primary-info">
      <div className="lead-list-view-details-view-box-primary-info-profile-edit">
        <div className="lead-list-view-details-view-box-primary-info-profile">
          <div className="lead-list-view-details-view-box-primary-info-profile-pic profile-upload-container">
            <ProfileImageUploadComponent
              imageUrl={
                isImageRemoved ? null : leadDetails?.lead_profile_file_Url
              }
              uploadedImage={uploadedImage}
              onImageUpload={handleProfileUpload}
              onRemoveImage={handleRemoveImage}
              viewFullInfoOpen={viewFullInfoOpen}
              placeholderImage={AvatarIcon}
              disableEditIcon={checkDisableField()}
            />
          </div>
          <div className="lead-list-view-details-view-box-primary-info-profile-details">
            <div className="lead-list-view-details-view-box-primary-info-profile-details-name">
              <RenderCellContent
                text={`${leadDetails?.first_name || ""} ${
                  leadDetails?.middle_name || ""
                } ${leadDetails?.last_name || ""}`}
              />
            </div>
            <div className="lead-list-view-details-view-box-primary-info-profile-details-contact">
              <span className="contact-item">
                <img src={PhoneIcon} alt="Phone" className="contact-icon" />
                {!leadDetails?.primary_phone_number ||
                leadDetails.primary_phone_number === "null" ||
                !isValidPhoneNumber(leadDetails.primary_phone_number) ? (
                  "-"
                ) : (
                  <ContactLink
                    type="Phone"
                    value={leadDetails.primary_phone_number}
                    id={leadDetails?.id}
                  />
                )}
              </span>
              <div className="contact-divider"></div>
              <span className="contact-item">
                {isTwilioConfigured ? (
                  <img
                    src={SMSIcon}
                    alt="SMS"
                    className="sms-icon"
                    style={{ cursor: "not-allowed", opacity: 0.5 }}
                    onClick={(e) => e.preventDefault()}
                  />
                ) : (
                  <img
                    src={SMSIcon}
                    alt="SMS"
                    className="sms-icon"
                    onClick={(e) => e.preventDefault()}
                  />
                )}
                {!leadDetails?.primary_phone_number ||
                leadDetails.primary_phone_number === "null" ||
                !isValidPhoneNumber(leadDetails.primary_phone_number) ? (
                  "-"
                ) : (
                  <ContactLink
                    type="SMS"
                    value={leadDetails.primary_phone_number}
                    id={leadDetails?.id}
                    setSendSmsPopupOpen={setSendSmsPopupOpen}
                  />
                )}
              </span>
              <div className="contact-divider"></div>
              <span className="contact-item">
                <img
                  src={MailIcon}
                  alt="Mail"
                  className="contact-icon mail-icon"
                />
                <ContactLink
                  type="Email"
                  className="contact-mail-icon"
                  value={leadDetails?.primary_email_address || "-"}
                  id={leadDetails?.id}
                />
              </span>
            </div>
          </div>
        </div>
        {/* {!viewPrimaryInfoOpen ? (
          <div className="lead-list-view-details-view-box-primary-info-edit">
            <button
              className="lead-list-view-edit-section"
              onClick={handleEditOpen}
            >
              Edit
            </button>
          </div>
        ) : (
          ""
        )} */}
      </div>
      {uploadError && <div className="error-message">{uploadError}</div>}
      {!isMobile && (
        <div className="lead-list-view-details-view-box-primary-info-other">
          <div className="lead-list-view-details-view-box-primary-info-other-section">
            <div className="lead-list-view-details-view-box-primary-info-other-section-main-text">
              Lead Owner
            </div>
            <div className="lead-list-view-details-view-box-primary-info-other-section-sub-text">
              {leadDetails?.owner?.first_name || ""}{" "}
              {leadDetails?.owner?.last_name || ""}
            </div>
          </div>
          <div className="lead-list-view-details-view-box-primary-info-other-section">
            <div className="lead-list-view-details-view-box-primary-info-other-section-main-text">
              Lead Source
            </div>
            <div className="lead-list-view-details-view-box-primary-info-other-section-sub-text">
              {leadDetails?.lead_source || "-"}
            </div>
          </div>
          <div className="lead-list-view-details-view-box-primary-info-other-section">
            <div className="lead-list-view-details-view-box-primary-info-other-section-main-text">
              Created By
            </div>
            <div className="lead-list-view-details-view-box-primary-info-other-section-sub-text">
              {leadDetails?.createdBy?.first_name || ""}{" "}
              {leadDetails?.createdBy?.last_name || ""}
            </div>
          </div>
          {tenantDetails?.tenantType !== "Tenant" && (
            <div className="lead-list-view-details-view-box-primary-info-other-section">
              <div className="lead-list-view-details-view-box-primary-info-other-section-main-text">
                Assigned Partner
              </div>
              <div className="lead-list-view-details-view-box-primary-info-other-section-sub-text">
                {leadDetails?.assignedTo?.company_name || "-"}
              </div>
            </div>
          )}
          <div className="lead-list-view-details-view-box-primary-info-other-section">
            <div className="lead-list-view-details-view-box-primary-info-other-section-main-text">
              Phone
            </div>
            <div className="lead-list-view-details-view-box-primary-info-other-section-sub-text">
              {!leadDetails?.primary_phone_number ||
              leadDetails.primary_phone_number === "null" ||
              !isValidPhoneNumber(leadDetails.primary_phone_number) ? (
                "-"
              ) : (
                <ContactLink
                  type="Phone"
                  value={leadDetails.primary_phone_number}
                  id={leadDetails?.id}
                />
              )}
            </div>
          </div>
          <div className="lead-list-view-details-view-box-primary-info-other-section">
            <div className="lead-list-view-details-view-box-primary-info-other-section-main-text">
              Lead Status
            </div>
            <div className="lead-list-view-details-view-box-primary-info-other-section-sub-text">
              <LeadsStatus status={leadDetails?.lead_status || "-"} />
            </div>
          </div>
        </div>
      )}
      {sendSmsPopupOpen && (
        <SendSmsPopup setSendSmsPopupOpen={setSendSmsPopupOpen} onSuccess={sendLeadSMS} />
      )}
    </div>
  );
};

export default LeadViewDetailsViewPrimaryInfo;
